import { IPropertyConverter, JsonValue } from "ta-json";

import { Object_Unknown } from "../base-types";
import { IRendition, IRenditionItem, Rendition } from "../contracts/base/rendition";
import { InvalidOperationError } from "../errors/invalid-operation-error";

export class RenditionsConverter implements IPropertyConverter {
    /**
     * Serializes an array of renditions into a Json Value.
     *
     * @param value - An array of renditions
     *
     * @returns A Json Value.
     */
    serialize(renditions: Array<IRendition>): JsonValue {
        const result: Object_Unknown = {};

        renditions.forEach(rendition => {
            result[rendition.name] = rendition.items;
        });

        return JSON.stringify(result);
    }

    /**
     * Deserializes a Json Value into an array of renditions.
     *
     * @param value - A Json Value
     *
     * @returns An array with Renditions.
     */
    deserialize(value: JsonValue): Array<IRendition> {
        if (!value) {
            throw new InvalidOperationError("Can't deserialize falsy value.");
        } else if (typeof value !== "object") {
            throw new InvalidOperationError(
                `Expected a value of type 'JSON', but value was of type '${typeof value}'.`
            );
        }

        const renditions: Record<string, Array<IRenditionItem>> = typeof value === "string"
            ? JSON.parse(value)
            : JSON.parse(JSON.stringify(value));

        const result: Array<IRendition> = [];

        Object.keys(renditions).forEach(renditionName => {
            const items: Array<IRenditionItem> = renditions[renditionName];
            result.push(Rendition.createRendition(renditionName, items));
        });

        return result;
    }
}
